import { render } from "./ReportsComponent.vue?vue&type=template&id=5fc9d06a"
import script from "./ReportsComponent.vue?vue&type=script&lang=js"
export * from "./ReportsComponent.vue?vue&type=script&lang=js"
script.render = render

export default script